import React, { createContext, useContext } from 'react';
import type { AdminPermissionsState } from '../../../services/adminAccessService';

export type AdminPermissionsContextValue = AdminPermissionsState & {
  setPreviewAsAnalyst: (enabled: boolean) => void;
};

const AdminPermissionsContext = createContext<AdminPermissionsContextValue | null>(null);

export function AdminPermissionsProvider({
  value,
  children,
}: {
  value: AdminPermissionsContextValue;
  children: React.ReactNode;
}) {
  return (
    <AdminPermissionsContext.Provider value={value}>
      {children}
    </AdminPermissionsContext.Provider>
  );
}

export function useAdminPermissions(): AdminPermissionsContextValue {
  const ctx = useContext(AdminPermissionsContext);
  if (!ctx) {
    throw new Error('useAdminPermissions must be used within AdminPermissionsProvider');
  }
  return ctx;
}

export function useAdminPermissionsOptional(): AdminPermissionsContextValue | null {
  return useContext(AdminPermissionsContext);
}
